const setBottomBarSessionState = () => sessionStorage.setItem("stickyBottomBarClosed", "true");

const isBottomBarClosed = () => sessionStorage.getItem("stickyBottomBarClosed") === "true";

export { setBottomBarSessionState, isBottomBarClosed };
